import socialApiClient from "../../helpers/services/social-api-client";
import { Media } from "../../socialPost/interfaces/api/get-social-posts";
import { Mentions } from "../../socialPost/interfaces/Mention";
import { PostImage } from "../../socialPost/interfaces/postImage";
import { PostVideo } from "../../socialPost/interfaces/postVideo";
import { blobFromDataURI } from "../../utils";
import {
  GetInstagramLoginBindResponse,
  GetInstagramLoginUrlResponse,
  PostInstagramLoginBindRequest,
  PostInstagramLoginBindResponse,
} from "../interface/api/instagram-login-api";
import { PostSocialPostResponse } from "../../instagram/interface/api/post-instagram-socialPost";
import { PutSocialPostResponse } from "../../instagram/interface/api/put-instagram-socialPost";
import { instagramLoginSettingMapper } from "./mapper";

export const instagramLoginApiService = {
  unbind(companyId: string) {
    return socialApiClient()
      .post(`instagram/login/unbind`, {}, { params: { companyId } })
      .then(({ data }) => data);
  },

  bind(companyId: string, body: PostInstagramLoginBindRequest) {
    return socialApiClient()
      .post<PostInstagramLoginBindResponse>(`instagram/login/bind`, body, {
        params: { companyId },
      })
      .then(({ data }) =>
        instagramLoginSettingMapper.mapResponseToInstagramLoginSetting(data)
      );
  },

  get(companyId: string) {
    return socialApiClient()
      .get<GetInstagramLoginBindResponse>(`instagram/login`, {
        params: { companyId },
      })
      .then(({ data }) =>
        instagramLoginSettingMapper.mapResponseToInstagramLoginSetting(data)
      );
  },

  login(companyId: string) {
    return socialApiClient()
      .get<GetInstagramLoginUrlResponse>(`instagram/login/login`, {
        params: { companyId },
      })
      .then(({ data }) =>
        instagramLoginSettingMapper.mapResponseToLoginUrl(data)
      );
  },

  socialPost(
    text: string,
    mentions: Mentions[],
    images: PostImage[],
    scheduleDate: string,
    repostId: string,
    companyId: string
  ) {
    const bodyFormData = new FormData();
    bodyFormData.append("text", text);
    bodyFormData.append("repostId", repostId);
    bodyFormData.append("mentions", JSON.stringify(mentions));
    images.forEach((image) =>
      bodyFormData.append("images", blobFromDataURI(image.data))
    );
    if (scheduleDate) bodyFormData.append("scheduleDate", scheduleDate);
    return socialApiClient()
      .post<PostSocialPostResponse>(`instagram/login/socialpost`, bodyFormData, {
        params: { companyId },
      })
      .then(({ data }) => data);
  },

  socialPostVideo(
    text: string,
    mentions: Mentions[],
    video: PostVideo,
    scheduleDate: string,
    repostId: string,
    companyId: string
  ) {
    const bodyFormData = new FormData();
    bodyFormData.append("text", text);
    bodyFormData.append("repostId", repostId);
    bodyFormData.append("mentions", JSON.stringify(mentions));
    bodyFormData.append("video", blobFromDataURI(video.data));
    if (scheduleDate) bodyFormData.append("scheduleDate", scheduleDate);
    return socialApiClient()
      .post<PostSocialPostResponse>(
        `instagram/login/socialpost/video`,
        bodyFormData,
        { params: { companyId } }
      )
      .then(({ data }) => data);
  },

  putSocialPost(
    id: string,
    text: string,
    mentions: Mentions[],
    images: PostImage[],
    scheduleDate: string,
    companyId: string,
    media: Media[]
  ) {
    const bodyFormData = new FormData();
    bodyFormData.append("text", text);
    bodyFormData.append("mentions", JSON.stringify(mentions));
    bodyFormData.append("media", JSON.stringify(media));
    images.forEach((image) =>
      bodyFormData.append("images", blobFromDataURI(image.data))
    );
    if (scheduleDate) bodyFormData.append("scheduleDate", scheduleDate);
    return socialApiClient()
      .put<PutSocialPostResponse>(`instagram/login/socialpost/${id}`, bodyFormData, {
        params: { companyId },
      })
      .then(({ data }) => data);
  },

  putSocialPostVideo(
    id: string,
    text: string,
    mentions: Mentions[],
    video: PostVideo | null,
    scheduleDate: string,
    companyId: string,
    media: Media[]
  ) {
    const bodyFormData = new FormData();
    bodyFormData.append("text", text);
    bodyFormData.append("mentions", JSON.stringify(mentions));
    bodyFormData.append("media", JSON.stringify(media));
    if (video) bodyFormData.append("video", blobFromDataURI(video.data));
    if (scheduleDate) bodyFormData.append("scheduleDate", scheduleDate);
    return socialApiClient()
      .put<PutSocialPostResponse>(
        `instagram/login/socialpost/video/${id}`,
        bodyFormData,
        { params: { companyId } }
      )
      .then(({ data }) => data);
  },
};
